/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { setTopologyGraphData } from "../store/slice/roomSlices/topologyRoomSlice"
import topologyFields from "../store/constants/topologyFields"
import store from "../store/store";

export const updateTopologyRoom = (path, data) => {
    const dispatch = store.dispatch;
    const keys = path.split("/:");
    const root = keys[0];

    switch (root) {
        case topologyFields.GRAPH:
            dispatch(setTopologyGraphData(data))
            break;

        default:
            console.log("case: ", root, "not yet implemented");
            break;
    }
};